import styles from './LocationHint.module.css'

interface LocationHintProps{
}

export const LocationHint = (props: LocationHintProps): JSX.Element => {
    return (
        <div className={styles.LocationHint}>
            Please <br/>
            Enter Your<br/>
            Location
        </div>
    )
}